// extracted by mini-css-extract-plugin
export var arrow = "_45-6";
export var changeItem = "_45-3";
export var changesHeader = "_45-1";
export var changesList = "_45-2";
export var container = "_45-0";
export var pathLabel = "_45-4";
export var value = "_45-7";
export var valuesContainer = "_45-5";